var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { DatePicker } from 'antd';
import { BLACK } from 'ui/constants';
var StyledDatePicker = styled(DatePicker)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width, margin = _a.margin, height = _a.height;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 6px;\n    height: ", ";\n    width: ", ";\n    margin: ", ";\n    .ant-picker-suffix {\n      color: ", ";\n    }\n  "], ["\n    border-radius: 6px;\n    height: ", ";\n    width: ", ";\n    margin: ", ";\n    .ant-picker-suffix {\n      color: ", ";\n    }\n  "])), height || 'auto', width || '100%', margin || 0, BLACK);
});
export default StyledDatePicker;
var templateObject_1, templateObject_2;
